/**
 * useResponsePairs Hook
 * Groups messages into user-assistant response pairs
 */

import React from 'react';
import { ChatMessage } from '@/types/chatTypes';

export interface ResponsePair {
  userMessage: ChatMessage;
  assistantMessage: ChatMessage;
}

export function useResponsePairs(messages: ChatMessage[]): ResponsePair[] {
  return React.useMemo(() => {
    const pairs: ResponsePair[] = [];

    for (let i = 0; i < messages.length; i++) {
      if (messages[i].role === 'user') {
        const assistantMsg = messages[i + 1];
        if (assistantMsg && assistantMsg.role === 'assistant') {
          pairs.push({
            userMessage: messages[i],
            assistantMessage: assistantMsg,
          });
          i++; // Skip the assistant message in next iteration
        }
      }
    }

    return pairs;
  }, [messages]);
}
